// extracted by mini-css-extract-plugin
export default {"editAttachmentModalFooter":"EditAttachmentModal__editAttachmentModalFooter___MwH80","editFooterRightContainer":"EditAttachmentModal__editFooterRightContainer___Zt3y1"};